var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73333 17.0667L5.6 12.9333C5.06667 12.4 5.06667 11.6 5.6 11.0667C6.13333 10.5333 6.93333 10.5333 7.46667 11.0667L10.6667 14.2667L17.2 7.73333C17.7333 7.2 18.5333 7.2 19.0667 7.73333C19.6 8.26667 19.6 9.06667 19.0667 9.6L11.6 17.0667C11.0667 17.6 10.2667 17.6 9.73333 17.0667ZM24 20V4C24 1.73333 22.2667 0 20 0H4C1.73333 0 0 1.73333 0 4V20C0 22.2667 1.73333 24 4 24H20C22.2667 24 24 22.2667 24 20ZM20 2.66667C20.8 2.66667 21.3333 3.2 21.3333 4V20C21.3333 20.8 20.8 21.3333 20 21.3333H4C3.2 21.3333 2.66667 20.8 2.66667 20V4C2.66667 3.2 3.2 2.66667 4 2.66667H20Z",
    fill: "#2B45D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.7c63e3e5442746204d12e0ecf5c9c252.svg";
export { ForwardRef as ReactComponent };